import BodyText, { BODY_TEXT_SIZES } from "@shared/ui/BodyText";
import Headline, { HEADLINE_SIZES } from "@shared/ui/Headline";
import React from "react";
import { useIntl } from "react-intl";
import SplashLogo from "@shared/svg/makula-logo.svg?react";

const SplashScreen = () => {
  const { messages } = useIntl();

  return (
    <div className="w-screen h-screen flex flex-col items-center justify-center gap-6">
      <div className="w-[64px] h-[64px] rounded-[11px] bg-[#172b4d] flex items-center justify-center mb-[20px] animate-bounce">
        <SplashLogo height="42px" width="34px" />
      </div>
      <div className="flex flex-col items-center gap-2 text-center max-w-container-xs">
        <Headline size={HEADLINE_SIZES.SMALL}>
          {messages?.common?.["splashScreen"].title}
        </Headline>
        <BodyText size={BODY_TEXT_SIZES.X_SMALL} color="text-secondary">
          {messages?.common?.["splashScreen"].subTitle}
        </BodyText>
      </div>
    </div>
  );
};

export default SplashScreen;
